import iClinicApi from 'services/iclinic/iClinicApi';

export const getPaymentSlipData = () =>
  iClinicApi.get('/payments/payment/get-bank-slip-url/');

export const postPaymentReleaseTrust = () =>
  iClinicApi.post('/payments/payment/releasetrust/');
